// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3sy9l","inner":"style_inner__1zs9U","bottom":"style_bottom__Dr5lk","copyright":"style_copyright__3DdWF"};